import { appUrls } from 'constants/urls';
import axiosInstance from 'utils/axiosInstance';
import { convertJalaiToMiladi } from 'utils/date-utils';

const fetchReportData = async (patientId, daysAgo) => {
  const url =
    +daysAgo === 365
      ? appUrls.GlucoseChart(patientId, 365)
      : appUrls.GlucoseChartAll(patientId);
  const { data } = await axiosInstance.get(url);
  return data;
};

const fetchSpeceficRangeReport = async ({ patientId, date }) => {
  const { from, to } = date || {};
  const { data } = await axiosInstance.get(
    appUrls.selectedDayReport(
      patientId,
      convertJalaiToMiladi(from),
      convertJalaiToMiladi(to)
    )
  );
  return data;
};

export { fetchReportData, fetchSpeceficRangeReport };
